// extracted by mini-css-extract-plugin
module.exports = {"input":"login_input-module__input--1zFV4","password":"login_input-module__password--1Lt3K"};